import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/Basket`;

function paramsToStringList(params) {
  let stringparams = "?";
  Object.entries(params).map(([key, value]) => {
      if (value !== undefined && value !== null)
          stringparams = stringparams + key + "=" + value + "&";
          return stringparams;
  })
  stringparams = stringparams.substr(0, stringparams.length - 1);
  return stringparams;
}

//testtt
const ApiBasket = {
  
  putAddOrEditeBasket: (params) => {
    
    const url = `${baseServiceUrl}/putAddOrEditeBasket`;
    

    return ServiceApi.put(url,params);
  },
 getAllBasketByStatus: (params) => {
    
    const url = `${baseServiceUrl}/GetAllBasketByStatus`;
    return ServiceApi.get(url,{params});
  },
  getBasketById: (params) => {
    const url = `${baseServiceUrl}/GetBasketById`+ paramsToStringList(params);
    return ServiceApi.get(url);
  },
  getBasketTemp: (params) => {
    
    const url = `${baseServiceUrl}/GetBasketTemp`;
    
    return ServiceApi.get(url);
  },
  putAddPromoCodeToBasket: (params) => {
    
    const url = `${baseServiceUrl}/putAddPromoCodeToBasket`;
    
    return ServiceApi.put(url,params);
  },
  getFile: (params) => {
    // const url = `${baseServiceUrl}/getFile`;
      
      return  ServiceApi.get(`/api/v1/filesservicecontroler/getFile`,  {params : params , responseType : 'blob'} );

  }, 
};

export default ApiBasket;